const WhatsAppButton = () => {
    return (
        <a
            href="https://wa.me/393478528235?text=Ciao%2C%20vorrei%20informazioni"
            target="_blank"
            rel="noreferrer"
            aria-label="Contattaci su WhatsApp"
            className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 rounded-full shadow-lg bg-[#25D366] hover:bg-[#1ebe5d] transition-colors"
        >
            <i className="icofont-whatsapp text-white text-3xl" aria-hidden="true"></i>
        </a>
    )
}

export default WhatsAppButton
